var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavoritesOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99965 3.26L9.37965 6.05L9.60965 6.55L10.1096 6.625L13.1896 7.07L10.9996 9.22L10.6246 9.585L10.7146 10.085L11.2396 13.15L8.48465 11.705L7.99965 11.5L7.53465 11.745L4.77965 13.17L5.27965 10.105L5.36965 9.605L4.99965 9.22L2.78965 7.045L5.86965 6.6L6.36965 6.525L6.59965 6.025L7.99965 3.26ZM7.99965 1L5.72465 5.61L0.639648 6.345L4.31965 9.935L3.44965 15L7.99965 12.61L12.5496 15L11.6796 9.935L15.3596 6.35L10.2746 5.61L7.99965 1Z",
    fill: "#171719"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoritesOutlined);
export default __webpack_public_path__ + "static/media/favorites-outlined.0aeda9a8af4a1fa6aab8a2a54cb26b86.svg";
export { ForwardRef as ReactComponent };